module.exports = "/_next/static/images/home-3dbb0a90f4628b544e7ac54c4fb3ae1f.svg";